document.addEventListener('cart:update', (e) => {
    const { data } = e.detail || {};

    // Only handle adds from the product form
    if (data?.source === 'product-form-component' && !data.didError) {
        if (typeof confetti === 'function') {
            const end = Date.now() + 1 * 1000;

            const colors = ["#F20505", "#078C03", "#F2CB05"];

            (function frame() {
                confetti({
                    particleCount: 2,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 },
                    colors: colors,
                });

                confetti({
                    particleCount: 2,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 },
                    colors: colors,
                });

                if (Date.now() < end) {
                    requestAnimationFrame(frame);
                }
            })();
        }
    }
});
